import PropTypes from 'prop-types';
import {SET_PROMO, SET_PROMO_FIELD, SET_LAYOUTS, SET_LOGOS, SET_PREVIEW_BOX, LOAD_FIELDS, SET_PROMO_RESPONSE, REDIRECT_TO_UPDATED_PROMO, SET_CLONE_PROMO, REDIRECT_TO_LIBRARY} from './Editor.actions';
import serialize from 'form-serialize';
import tbkApi from '../../services/tbkApi';
import { fetchPromotions, fetchLocations, getPromoActiveCount } from '../App';
import {t} from 'i18next';
import { toast } from 'react-toastify';

export const propTypes = {
	promo: PropTypes.object,
	layouts: PropTypes.object,
	logos: PropTypes.object,
	preview_box: PropTypes.string,
	fields: PropTypes.object,
	response: PropTypes.object,
	redirectTo: PropTypes.string,
	clonedPromo: PropTypes.object,
};

export const defaultProps = {
	promo: null,
	layouts: {},
	logos: {},
	preview_box: 'a',
	fields: null,
	response: {},
	redirectTo: null,
	clonedPromo: null,
};

export const mapStateToProps = {
	editor: (state, action) => {
		switch (action.type) {
			case SET_PROMO:
				return {
					...state,
					promo: action.promo ? {
						...action.promo,
						_preview_coupon: state.promo ? state.promo._preview_coupon : null // done to remember if we were previewing coupon after hitting save
					} : null,
					clonedPromo: action.clearCloned ? null : state.clonedPromo
				};
			case SET_LAYOUTS:
				return {
					...state,
					layouts: action.layouts
				};
			case SET_LOGOS:
				return {
					...state,
					logos: action.logos
				};
			case LOAD_FIELDS:
				return {
					...state,
					fields: action.fields
				};
			case SET_PROMO_FIELD:
				let { field, value } = action;

				// What we're doing here is accounting for group fields, where "field" will be some_field[sub_field].
				// We're massaging field & value to just override subfield.
				const matches = field.match( /^(.+)\[([^\]]+)]/ );
				if ( matches ) {
					field = matches[1];
					value = {
						...( state.promo[ field ] || {} ),
						[matches[2]]: action.value
					};
				}

				return {
					...state,
					promo: {
						...state.promo,
						[field]: value
					}
				};
			case SET_PROMO_RESPONSE:
				return {
					...state,
					response: action.response
				};
			case SET_PREVIEW_BOX:
				return {
					...state,
					preview_box: action.value
				};
			case REDIRECT_TO_UPDATED_PROMO:
				return {
					...state,
					redirectTo: action.promo ? '/editor/' + action.promo.ID : null
				};
			case REDIRECT_TO_LIBRARY:
				return {
					...state,
					redirectTo: '/library/'
				};
			case SET_CLONE_PROMO:
				return {
					...state,
					clonedPromo: {
						...action.promo,
						ID: undefined,
					}
				};
			default:
				return state;
		}
	}
}

export const mapDispatchToProps = {
	onChangeField: e => {
		const field = e.target;
		return dispatch => {
			dispatch({
				type: SET_PROMO_FIELD,
				field: field.name,
				value: field.value
			})
		}
	},

	onChangePreview: e => {
		return dispatch => {
			dispatch({
				type: SET_PREVIEW_BOX,
				value: e
			})
		}
	},
	onSubmit: e => {
		e.preventDefault();
		const submit = e.target.querySelector('[type="submit"]');
		return dispatch => {
			// clear out any existing message
			const promo = serialize(document.getElementById('editor-form'), 'hash');
			const status = promo.post_status;
			const count = getPromoActiveCount( promo );
			const pendingCount = ( 'draft' === status ) ? getPromoActiveCount( promo, 'pending' ) : 0; // only care about this if we're saving a draft
			let confirmationString = false;
			if ( 'draft' === status ) {
				if ( count || pendingCount ) {
					confirmationString = t('This promo is currently active or pending on %d site(s).  If you continue to archive this promo, it will be immediately removed from all of those sites.  Continue?',{postProcess: 'sprintf', sprintf: [ count + pendingCount ]})
				}
			} else {
				if ( count ) {
					confirmationString = t('This promo is currently active on %d site(s).  Are you sure you want to make this change?',{postProcess: 'sprintf', sprintf: [ count ]});
				}
			}
			const confirmed = ! confirmationString || window.confirm( confirmationString );

			if ( ! confirmed ) {
				return;
			}
			submit.disabled = true;
			dispatch({
				type: SET_PROMO_RESPONSE,
				response: null,
			});
			tbkApi.savePromotion( promo ).then(response => {
				toast.dismiss();
				submit.disabled = false;
				if ( 'success' === response.type ) {

					toast("Success! Promotion saved.", {
						autoClose: true,
						type: toast.TYPE.SUCCESS,
					});
					dispatch( fetchPromotions() );
					if ( 'draft' === promo.post_status && ( count || pendingCount ) ) {
						// If we've archived a promo, and we've removed it from active or pending on any sites,
						// we need to re-fetch locations in order to update the library & manager views
						dispatch( fetchLocations() );
					}
					dispatch({
						type: SET_PROMO,
						promo: response.promo
					});
					dispatch({
						type: REDIRECT_TO_UPDATED_PROMO,
						promo: response.promo
					});
				} else {
					toast(response.message, {
						autoClose: false,
						type: toast.TYPE.ERROR,
					});
					dispatch({
						type: SET_PROMO_RESPONSE,
						response
					});
				}
			});
		}
	},
	onClone: promo => {
		return dispatch => {
			dispatch({
				type: SET_CLONE_PROMO,
				promo
			});
		}
	},
	onForceStatusChange: ( promo, status ) => {
		return dispatch => {
			document.getElementById('post_status').value = status;
			document.getElementById('editor-form').querySelector('[type="submit"]').click();
		}
	},
	onDelete: promo => {
		return dispatch => {
			const count = getPromoActiveCount( promo );
			let confirmationString = getPromoActiveCount( promo )
				? t('This promotion is currently active on %d site(s).  If you delete it, it will immediately be removed from all sites.  Continue?', {postProcess: 'sprintf', sprintf: [ count ] } )
				: t('Are you sure you want to permanently delete this promotion?')
			;
			if ( window.confirm( confirmationString ) ) {
				document.getElementById('editor-form').querySelector('[type="submit"]').disabled = true;
				tbkApi.deletePromotion( promo.ID ).then(() => {
					dispatch( fetchPromotions() );
					dispatch( fetchLocations() );
					dispatch({
						type: REDIRECT_TO_LIBRARY
					});
				});

			}
		}
	},
	onTabSelect: tab => {
		return dispatch => {
			const tabsOfInterest = [
				'field_5be1b33e678a3', // Coupon Details
				'field_5be1aed69f80f', // Custom Design Images
				'field_5be1a9369f804', // Plug & Play Details
			];
			if ( tabsOfInterest.indexOf( tab ) !== -1 ) {
				dispatch({
					type: SET_PROMO_FIELD,
					field: '_preview_coupon',
					value: ( 'field_5be1b33e678a3' === tab )
				})
			}
		}
	}
};